export function createAVLNode(key, value) {
    return {
        key,
        value,
        left: null,
        right: null,
        height: 0
    };
}

//# sourceMappingURL=node.js.map